// Copyright (c) 2016 Deere & Company

import './tab-navigation.scss';
import React, {PropTypes} from 'react';
import Tab from './tab';
import TabState from '../../state/tab';

const TabNavigation = props =>
    <ul className='tab-navigation'>
        {props.tabs.map((tab, index) =>
            <li key={index}>
                <Tab tab={tab}/>
            </li>
        )}
    </ul>;

TabNavigation.displayName = 'TabNavigation';
TabNavigation.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.instanceOf(TabState)).isRequired
};

export default TabNavigation;



// WEBPACK FOOTER //
// ./src/shared/components/tab-navigation/index.js